import React from 'react';

interface MarqueeProps {
    items: React.ReactNode[];
    /** Seconds for one full pass. */
    speed?: number;
    reverse?: boolean;
    className?: string;
}

/**
 * Infinite horizontal ticker. The track is rendered twice and translated by
 * exactly -100%, so the second copy lands where the first started and the
 * loop has no visible seam. Pauses on hover.
 */
const Marquee: React.FC<MarqueeProps> = ({ items, speed = 34, reverse = false, className = '' }) => {
    const track = (key: string, hidden: boolean) => (
        <div className="marquee__track" key={key} aria-hidden={hidden || undefined}>
            {items.map((item, i) => (
                <span className="marquee__item" key={`${key}-${i}`}>
                    {item}
                </span>
            ))}
        </div>
    );

    return (
        <div
            className={`marquee ${reverse ? 'marquee--reverse' : ''} ${className}`}
            style={{ ['--marquee-speed' as string]: `${speed}s` }}
        >
            {track('a', false)}
            {track('b', true)}
        </div>
    );
};

export default Marquee;
